import {useGetData} from '../../src/apiservice/apiCall'


export function useConcernMenu(){
	return useGetData('/api/WebApi/GetConcern')
}
